var _a;
var COIN_SIZES = {
    Small: "small",
    Medium: "medium",
    Large: "large",
};
var sizes = (_a = {},
    _a[COIN_SIZES.Small] = 24,
    _a[COIN_SIZES.Medium] = 36,
    _a[COIN_SIZES.Large] = 42,
    _a);

export { COIN_SIZES, sizes };
